module.exports = __webpack_public_path__ + "media/images/training_block_3-d12043e0428757231510f55af97a5a6c.png";